
import { useResearchItemDetails } from '../use-research-item-details';

interface UseSelectedResearchDataProps {
  selectedResearchId: string | null;
}

export const useSelectedResearchData = ({ selectedResearchId }: UseSelectedResearchDataProps) => {
  // Fetch detailed research data for the lightbox - only depends on selectedResearchId
  const {
    data: selectedResearchDetails,
    isLoading: isLoadingDetails,
  } = useResearchItemDetails(selectedResearchId);

  return {
    selectedResearchDetails,
    isLoadingDetails,
  };
};
